var _defs, _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.54 41.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f48d21;\n      }\n\n      .cls-2 {\n        fill: #007da5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.49,9.58c-8.82,0-15.98,7.11-15.98,15.87s7.16,15.86,15.98,15.86,15.98-7.11,15.98-15.86-7.15-15.87-15.98-15.87ZM61.77,15.34c-.02.14-.07.29-.13.44-.03.06-.06.13-.09.2-.4.72-1.16,1.2-2.04,1.2-3.4,0-6.33,2.01-7.64,4.9-.06.12-.12.24-.16.37-.1.25-.19.51-.27.77-.03.14-.07.27-.1.41-.14.59-.21,1.22-.21,1.87,0,.32-.07.62-.18.9-.02.03-.04.07-.05.1-.03.07-.07.14-.11.2-.17.28-.41.53-.67.71-.11.07-.2.12-.3.17-.3.14-.64.22-1,.22-1.28,0-2.31-1.03-2.31-2.3,0-4.74,2.57-8.88,6.4-11.14.14-.08.27-.16.42-.23.13-.07.27-.15.41-.22.05-.02.1-.04.15-.07.09-.04.18-.09.27-.13.35-.15.68-.29,1.04-.42.15-.04.31-.1.45-.14.16-.05.3-.09.46-.14.22-.05.42-.1.63-.14.06-.01.1-.02.16-.04.84-.18,1.72-.27,2.61-.27,1.28,0,2.32,1.04,2.32,2.32,0,.16-.02.31-.06.46Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.14,
    y: 0,
    width: 5.64,
    height: 40
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.54,25.45c0-8.71-7.06-15.77-15.77-15.77s-15.77,7.06-15.77,15.77,7.06,15.78,15.77,15.78c7.12,0,13.13-4.71,15.1-11.2h-5.91c-1.69,3.37-5.17,5.69-9.18,5.69-5.34,0-9.72-4.08-10.21-9.28h25.94c.02-.33.03-.66.03-.99ZM120.56,20.92c1.68-3.39,5.17-5.72,9.2-5.72s7.53,2.33,9.21,5.72h-18.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.55,25.31c0,1.5-.21,2.94-.6,4.32-1.88,6.61-7.96,11.46-15.18,11.46-8.71,0-15.77-7.07-15.77-15.78s7.06-15.77,15.77-15.77c6.83,0,12.64,4.34,14.84,10.41h-6.09c-1.81-2.94-5.04-4.9-8.75-4.9-5.67,0-10.26,4.59-10.26,10.26s4.59,10.26,10.26,10.26c4.12,0,7.68-2.43,9.31-5.94h-10.7v-5.45h17.13c.02.38.04.76.04,1.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.58,9.54c-3.91,0-7.5,1.43-10.26,3.79V0h-5.51v25.46c.08,8.64,7.11,15.62,15.77,15.62s15.78-7.05,15.78-15.77-7.07-15.77-15.78-15.77ZM94.58,35.57c-5.62,0-10.18-4.51-10.26-10.11v-.31c.09-5.59,4.65-10.1,10.26-10.1s10.26,4.59,10.26,10.26-4.59,10.26-10.26,10.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeLogo);
export default __webpack_public_path__ + "static/media/globe-logo.254df1f03c35e74ad00275c67fad5a7e.svg";
export { ForwardRef as ReactComponent };